// @(name)[{ key: 'value, including (brackets)' }]
export const quillVariableObjectRegex = /@\[([^\]]+|[^\)]+)\]\(([^)]*?\{[^}]*\}[^)]*)\)/g
